// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 252) return "css/runtime-main.31d6cfe0.css";
	if (chunkId === 179) return "css/main.060e6af8.css";
	// return url for filenames based on template
	return "css/" + ({"194":"user-panel","289":"administration","996":"info"}[chunkId] || chunkId) + "." + {"194":"a8736712","289":"5dff1b63","723":"31d6cfe0","790":"31d6cfe0","996":"31d6cfe0"}[chunkId] + ".chunk.css";
};